module.exports = __webpack_public_path__ + "img/mesa_el_b.20bf0696.png";